import { faX } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@mui/material';
import './styles.scss';

interface IConfirmResetModal {
  open: boolean;
  handleClose: () => void;
  handleResetData: () => void;
}

const ConfirmResetModal = ({ open, handleClose, handleResetData }: IConfirmResetModal) => {
  const resetData = () => {
    handleClose();
    handleResetData();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div className="confirm-reset-modal-container">
        <div className="confirm-reset-modal-content">
          <div className="header">
            <h1>Are you sure you would like to reset the data?</h1>

            <Button className="close-button" onClick={handleClose}>
              <FontAwesomeIcon icon={faX} />
            </Button>
          </div>

          <div className="subtitle">All the data in this tab will be restored to default.</div>

          <div className="buttons">
            <Button className="cancel-button" onClick={handleClose}>
              Cancel
            </Button>
            <Button className="restore-button" onClick={resetData}>
              Restore to default
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmResetModal;
